import { render, staticRenderFns } from "./monthly-sale-item.vue?vue&type=template&id=09764fe0"
import script from "./monthly-sale-item.vue?vue&type=script&lang=js"
export * from "./monthly-sale-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports